import { Theme } from '@mui/material';

export const buttonStyles = (theme: Theme) => ({
  MuiButton: {
    styleOverrides: {
      root: {
        borderRadius: '4px',
        boxShadow: 'none',
        textTransform: 'none',
        alignItems: 'center',
        height: '36px',
        width: 'fit-content',
        padding: '0 24px',
        textWrap: 'nowrap',
        '&:hover': {
          boxShadow: 'none',
        },
        '&.Mui-disabled': {
          opacity: 0.5,
        },
        // '@media (max-width: 600px)': {
        //   width: '100%', // Full width on small screens
        // },
      },
      fullWidth: {
        width: '100%',
      },
      containedPrimary: {
        background: theme.palette.primary.main,
        color: theme.palette.text.primary,
        border: `1px solid ${theme.palette.primary.light}`,
        fontsize: '14px',
        '@media(hover: hover)': {
          '&:hover': {
            transition: '.2s ease-in-out',
            background: `${theme.palette.primary.contrastText}`,
            border: `1px solid ${theme.palette.primary.dark}`,
          },
        },
        '&.Mui-disabled': {
          background: `${theme.palette.primary.contrastText}`,
        },
      },

      // sizeSmall: {
      //   height: "36px",
      //   fontWeight: 400,
      //   padding: "7px 24px 5px 24px",
      //   fontSize: "16px",
      //   lineHeight: "24px",
      //   letterSpacing: "0.128px",
      //   display: "flex",
      //   justifyContent: "center",
      //   alignItems: "flex-end",
      //   gap: "10px",
      // },
      // sizeMedium: {
      //   height: "44px",
      //   fontWeight: 700,
      //   padding: "11px 24px 9px 24px",
      //   fontSize: "16px",
      //   lineHeight: "24px",
      //   letterSpacing: "0.128px",
      //   width: "100%",
      // },
      // sizeLarge: {
      //   height: "56px",
      //   paddingTop: "15px",
      //   paddingBottom: "13px",
      //   paddingLeft: "65px",
      //   paddingRight: "65px",
      //   fontWeight: 700,
      //   fontSize: "20px",
      //   lineHeight: "28px",
      //   letterSpacing: "0.16px",
      //   width: "100%",
      // },
      //   containedPrimary: {
      //     background: `${colors.mediumNavy}`,
      //     color: `${colors.white}`,
      //     boxShadow: "none",
      //     "@media(hover: hover)": {
      //       "&:hover": {
      //         transition: ".2s ease-in-out",
      //         background: `${colors.navy}`,
      //       },
      //     },
      //     "&.Mui-disabled": {
      //       background: `${colors.mediumLightNavy}`,
      //       color: `${colors.white}`,
      //     },
      //   },
      //   containedSecondary: {
      //     color: `${colors.mediumNavy}`,
      //     background: `${colors.lightNavy}`,
      //     // stroke: `${colors.mediumNavy}`,
      //     fill: `${colors.mediumNavy}`,

      //     "@media(hover: hover)": {
      //       "&:hover": {
      //         transition: ".2s ease-in-out",
      //         background: `${colors.mediumNavy}`,
      //         color: `${colors.white}`,
      //         // stroke: `${colors.white}`,
      //         fill: `${colors.white}`,
      //       },
      //     },
      //   },
      outlinedPrimary: {
        border: `1px solid ${
          theme.palette.mode === 'dark' ? '#363636' : '#d4d4d4'
        }`,
        color: theme.palette.text.primary,
        background: theme.palette.mode === 'dark' ? '#242424' : '#fdfdfd',
        '&:hover': {
          border: `1px solid ${
            theme.palette.mode === 'dark' ? '#454545' : '#8f8f8f'
          }`,
          background: theme.palette.mode === 'dark' ? '#242424' : '#ededed',
        },
      },
    },
  },
});
